export function getRequestHeaders(token: string) {
  return {
    Authorization: token ? `Bearer ${token}` : undefined,
    'x-no-gzip-response': 'true',
  };
}
